// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/spotlight.css
// module id = 6365
// module chunks = 0